import React, { useEffect, useState } from "react";
import { Bookmark } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { UpdateCard } from "@/components/UpdateCard";
import { Skeleton } from "@/components/ui/skeleton";
import { Link } from "react-router-dom";

export default function Saved() {
  const { user } = useAuth();
  const [list, setList] = useState(null);
  const load = () => api.get("/updates", { params: { saved: true } }).then(({ data }) => setList(data));
  useEffect(() => { if (user && user.id) load(); }, [user]);

  if (user === false) return (
    <div className="p-8 text-center">
      <Bookmark className="mx-auto mb-3 h-10 w-10 text-slate-300" />
      <p className="text-sm text-slate-500">Sign in to view your saved updates.</p>
      <Link to="/login" className="mt-3 inline-block rounded-full bg-medorange px-5 py-2 text-sm font-semibold text-white">Sign in</Link>
    </div>
  );

  return (
    <div className="px-4 py-4 pb-8">
      <h1 className="mb-4 font-heading text-xl font-extrabold text-slate-900">Saved Updates</h1>
      <div className="space-y-4">
        {list === null && [1, 2].map((i) => <Skeleton key={i} className="h-40 w-full rounded-2xl" />)}
        {list && list.length === 0 && <p className="py-10 text-center text-sm text-slate-400">Nothing saved yet.</p>}
        {list && list.map((u) => <UpdateCard key={u.id} update={u} onChange={load} />)}
      </div>
    </div>
  );
}
